import productInfoModal from '../components/productInfoModal';

productInfoModal.init();
